import request from '@/utils/request'

// 获取毕业生信息
export const GetGraduatesAPI = (data) => request.get('/users/graduation/', { params: data })

// 删除毕业生
export const DelGradAPI = (id) => request.delete(`/users/graduation/${id}/`)
